import React from "react";
import styled from "styled-components";
// @ts-ignore
import { CWBTooltip } from "cwb-react";
import { StyledCheckbox } from "../helpers/styles";
import { RouteComponentProps } from "react-router-dom";
import { connect } from "react-redux";
import { withI18n } from 'react-i18next';
import TeamShareRowComponent from "./TeamShareRowComponent";

interface IProps extends StateProps, DispatchProps, RouteComponentProps<any> {
  t: any,
  teamShareId: number
}

interface IState {
  checkedList?: any,
  colChoices?: any
}

class TeamShareComponent extends React.Component<IProps, IState> {
  public state: IState = {
    checkedList: {},
    colChoices: {}
  };

  setColChoices = async (isChecked: boolean, choiceLevelId: number) => {
    const {selectedTsInfo, setTSInfo} = this.props;
    selectedTsInfo.roles.forEach((role: any) => {
      if (choiceLevelId > -1) {
        role.choices.forEach((choice: any) => {
          if (choice.choiceLevelId === choiceLevelId) {
            const index = role.options.indexOf(role.options.find((option: any) => option.choiceLevelId === choiceLevelId));
            isChecked ? (index === -1 && role.options.push({choiceLevelId})) : (index > -1 && role.options.splice(index, 1));
          }
        });
      } else {
        const index = role.options.indexOf(role.options.find((option: any) => option.choiceLevelId === choiceLevelId));
        isChecked ? (index === -1 && role.options.push({choiceLevelId})) : (index > -1 && role.options.splice(index, 1));
      }
    })
    await setTSInfo(selectedTsInfo);
  }

  renderTableHeader = (tsInfo: any) => {
    const { colChoices, t } = this.props;
    return <thead key={`${tsInfo.teamShareId}_thead`}>
      <tr key={`${tsInfo.teamShareId}_thead_row`}>
        <th className="from-col"><RoleNameCellHeader>{`${t("Imported from")}:`}</RoleNameCellHeader></th>
        <th className="to-col">{t('TO')}</th>
        <th><ul>
        {tsInfo.reportColumns && tsInfo.reportColumns.map((choice: any, index:number) => {
          return <li key={`${tsInfo.teamShareId}_${index}`}>
            {colChoices[choice.choiceLevelId] ? <StyledHeader>
              {t(choice.description)}
              <StyledCheckbox key={`${choice.choiceLevelId}_col_choice`}
                    className={"header-cb"}
                    isChecked={this.state.checkedList[choice.choiceLevelId]}
                    onClick = {async () => {
                      let checkedList: any = this.state.checkedList;
                      checkedList[choice.choiceLevelId] = !this.state.checkedList[choice.choiceLevelId];
                      await this.setState({checkedList});
                      await this.setColChoices(this.state.checkedList[choice.choiceLevelId], choice.choiceLevelId);
                    }}
              />
            </StyledHeader> : <>{t(choice.description)}</>}
          </li>
        })}
        <li>{t('Select All')}</li>
        </ul></th>
      </tr>
    </thead>
  }

  deleteTeamShare = () => {
    const { selectedTsInfo, removeTeamShare, openConfirmModal, closeModal, t } = this.props;
    openConfirmModal({
      title: t('Remove TeamShare'),
      message: t('Are you sure you want to remove the TeamShare?'),
      onConfirm: () => {
        removeTeamShare(selectedTsInfo.teamShareId);
        closeModal();
      }
    })
  }

  render() {
    const { selectedTsInfo, t } = this.props;

    if(!selectedTsInfo) {
      return null;
    }

    return (
        <StyledDiv key={`${selectedTsInfo.teamShareId}_div`}>
          <TitleWrapper>
            <TSTitle>{selectedTsInfo.teamShareTitle}</TSTitle>
            <div>
              <RemoveIcon id={'Remove-' + selectedTsInfo.teamShareId}
                          className="icon-cwb-close-popup"
                          onClick={this.deleteTeamShare}
              ></RemoveIcon>
              <CWBTooltip target={'Remove-' + selectedTsInfo.teamShareId}>{t('Remove TeamShare')}</CWBTooltip>
            </div>
          </TitleWrapper>
          {selectedTsInfo && <Wrapper>
            <table>
              {this.renderTableHeader(selectedTsInfo)}
              <tbody>
                <TeamShareRowComponent {...this.props}></TeamShareRowComponent>
              </tbody>
            </table>
          </Wrapper>}
        </StyledDiv>
    );
  }
};

const StyledDiv = styled.div`
  width: 100%;
  margin: 32px 0;
`

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  border: 1px solid #CDCFD2;
  border-radius: 4px 4px 0 0;
`

const TSTitle = styled.div`
  color: #4A4A4A;
  letter-spacing: 0.12px;
  font-size: ${p => p.theme['xxl-font-size']} !important;
  font-weight: ${p => p.theme['font-weight-600']};
  line-height: 24px;
  margin-bottom: 0px;
  background: white;
  padding: 18px 0px 18px 20px;
`

const RemoveIcon = styled.div`
  background-color: #B5BBC6;
  border-radius: 25px;
  padding: 10px;

  position: relative;
  bottom: 32px;
  left: 16px;

  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;

  &:before{
    color: ${p => p.theme.white};
    font-size: ${p => p.theme['xs-font-size']};
  }

  &:hover{
    transform: scale(1.2, 1.2);
  }
`


const Wrapper = styled.div`
  border: none;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(227, 227, 227, 0.5);
  margin-bottom: 32px;

  table {
      margin-bottom: 0;
      width: 100%;
      background-color: white;
      border: 1px solid #C2C4CA;
      border-radius: 0 0 4px 4px;
      margin-bottom: 50px;

      border-collapse: separate;
      border-spacing: 0;
      border-top: 0;

      thead {
        th {
          min-width: 80px;

          vertical-align: middle !important;
          border-bottom: ${p => p.theme['border-2']} !important;
          height: 52px;
          line-height: 36px;
          border-color: ${p => p.theme.lightGrey};

          color: #758196;
          white-space: nowrap;
          font-size: 9px;
          font-weight: ${p => p.theme['font-weight-800']};
          letter-spacing: 0.5px;
          line-height: 16px;
          text-transform: uppercase;
          white-space: nowrap;

          *{
            color: #758196;
            font-size: 9px;
          }
        }
      }

      tbody {
        td{
          min-width: 80px;

          color: ${p => p.theme.grey};
          font-size: ${p => p.theme['s-font-size']} !important;
          padding-top: 14px 0 14px 16px;
          border-color: ${p => p.theme.lightGrey};
          border-bottom: ${p => p.theme['border-2']};
          vertical-align: middle !important;
        }
      }

      .from-col{
        min-width: 220px;
        max-width: 220px;
        width: 220px;
      }
      .to-col{
        min-width: 150px;
        max-width: 150px;
        width: 150px;
      }

      @media all and (max-width: 1040px) {
        .from-col{
          min-width: 110px;
          max-width: 110px;
          width: 110px;
        }
        .to-col{
          min-width: 80px;
          max-width: 80px;
          width: 80px;
        }
      }

      ul{
        height: 100%;
        list-style-type: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;

        li {
          align-items: center;
          justify-content: center;
          display: flex;
          position: relative;
          height: 36px;
          min-width: 12%;
          width: auto;
          flex-wrap: wrap;
          white-space: pre-line;
          padding: 0 2px;
        }
      }
  }

  .cwb-dropdown-wrapper, .cwb-dropdown-wrapper > div{
    min-width: 110px !important;
    max-width: 110px !important;
    width: 110px !important;
    margin-left: 0 !important

    @media all and (max-width: 1040px) {
      min-width: 80px !important;
      max-width: 80px !important;
      width: 80px !important;
    }
  }

  .cwb-dropdown-wrapper {
    .cwb-dropdown__menu{
      min-width: 150px;
    }

    .cwb-dropdown__menu-list{
      padding: 0;
    }
    
    .to-dropdown{
      .cwb-dropdown__indicator{
        margin-right: 8px;
        
        &.cwb-dropdown__clear-indicator{
          margin-right: 4px;
        }
      }
    }
  }

  .icon-cwb-checked, .icon-cwb-checked:before,
  .icon-cwb-unchecked, .icon-cwb-unchecked:before{
    font-size: ${p => p.theme['xxl-font-size']};
  }
`

const RoleNameCellHeader = styled.div`
  padding-left: 16px;
`

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column-reverse;
`

interface StateProps {
  requestData: any,
  selectedTsInfo: any,
  bdRoles: any,
  roleTypes: any,
  genders: any,
  roleSpots: any,
  colChoices: any
}

function mapStateToProps(state: any, ownProps: any): StateProps {
  const selectedTsInfo = state.scheduling.selectedTsInfo[ownProps.teamShareId];
  let colChoices: any = {};
  selectedTsInfo && selectedTsInfo.reportColumns.forEach((choice: any) => {
    let isChoicePresent = false;
    selectedTsInfo.roles.forEach((role: any) => {
      const present = role.choices.find((roleChoice: any) => roleChoice.choiceLevelId === choice.choiceLevelId)
      if (present) isChoicePresent = true;
    })
    colChoices[choice.choiceLevelId] = choice.choiceLevelId > -1 ? isChoicePresent : true;
  });
  return {
    requestData: state.scheduling.requestData,
    selectedTsInfo,
    bdRoles: state.scheduling.bdRoles,
    roleTypes: state.scheduling.roleTypes,
    genders: state.scheduling.genders,
    roleSpots: state.scheduling.roleSpots,
    colChoices
  };
}

interface DispatchProps {
  closeModal: () => void,
  openModal: ({className, title, message, onConfirm, onCancel, children, buttons}: any) => void,
  openConfirmModal: ({title, message, onConfirm, onCancel, buttons}: any) => void,
  setTSInfo: (header?: any, teamShare?: any, scheduling?: any) => void,
  removeTeamShare: (teamShareId: any) => void,
  setNewRole: ({newRoleInfo, isCommercial}: any) => void
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    openModal: dispatch.modal.openModal,
    openConfirmModal: dispatch.modal.openConfirmModal,
    closeModal: dispatch.modal.closeModal,
    setTSInfo: dispatch.scheduling.setTSInfo,
    removeTeamShare: dispatch.scheduling.removeTeamShare,
    setNewRole: dispatch.scheduling.setNewRole
  };
}

export default withI18n()(connect<StateProps, DispatchProps, {}>(mapStateToProps, mapDispatchToProps)(TeamShareComponent));
